export default __webpack_public_path__ + "static/media/money_Unlocked.d149fdbb.png";